import React from 'react';
import Select from 'react-select';


const userRoles = [
  { value: 0, label: 'GP' },
  { value: 1, label: 'GP Trainee' },
  { value: 2, label: 'Practice Nurse' },
  { value: 3, label: 'Consultant' },
  { value: 4, label: 'NCHD (Hospital Doctor)' },
  { value: 6, label: 'Nurse Specialist' }
]

class AdminUserTypeSelect extends React.Component {

  render () {
    const {value, onChange, errors} = this.props;
    const hideSelectAll = value.length == userRoles.length;
    const hideDeselectAll = value.length == 0;

    return (
      <div>
        <div className="col s12">
          {/* <p className="input_country"><div style={{marginBottom: '11px'}}></div></p> */}
          <Select
            options={userRoles}
            placeholder='Select user types'
            value={value}
            onChange={onChange}
            multi={true}
          />
          <div style={{ color: 'red', fontSize: '0.875rem' }}>
            {(errors || []).join('. ')}
          </div>
        </div>
        <div>
          <a className={`${hideSelectAll && 'hide'}`}
            href="javascript:void(0)" onClick={() => {
            onChange(userRoles)
          }}>
            Select all
          </a>&nbsp;
          <a className={`${hideDeselectAll && 'hide'}`}
            href="javascript:void(0)" onClick={() => {
            onChange([])
          }}>
            Deselect all
          </a>
        </div>
      </div>
    )
  }
}

export default AdminUserTypeSelect;


/** WEBPACK FOOTER **
 ** ./src/containers/Input/AdminUserTypeSelect.jsx
 **/